/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AutoTaggingJobSwagger } from 'src/customText/core/services/autoTagging/customTextAutoTaggingSwagger';
import { AutoTaggingJobStore } from 'src/customText/core/stores/CustomTextAutoTaggingJobStore';

export const autoTaggingJobInfoSwaggerToAutoTaggingJobInfoStore = (swagger: AutoTaggingJobSwagger): AutoTaggingJobStore =>
    new AutoTaggingJobStore(swagger.jobId, {
        trainedModelLabel: swagger.trainedModelLabel,
        percentage: swagger.percentage,
        errors: swagger.errors,
        status: swagger.status === 'running' ? 'inProgress' : swagger.status,
        createdDateTime: swagger.createdDateTime ? new Date(swagger.createdDateTime) : null,
        expirationDateTime: swagger.expirationDateTime ? new Date(swagger.expirationDateTime) : null,
        lastUpdatedDateTime: swagger.status === 'succeeded' ? new Date(swagger.lastUpdatedDateTime) : null,
        documents: swagger.documents,
        extractors: swagger.extractors,
        totalCharsCount: swagger.totalCharsCount
    });
